import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../services/auth/auth.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class LandingComponent implements OnInit {
  hasReloaded:boolean = false;
  loading:boolean = false;

  constructor(
    private authService: AuthService,
    private cookies: CookieService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.checkAndReload();
  }

  checkAndReload(): void {
    this.loading = true;
    // Check if 'hasReloaded' exists in session storage
    this.removeChatbotScript();
    if (sessionStorage.getItem('hasReloaded')) {
      window.location.reload();
      sessionStorage.removeItem('hasReloaded');
    } else {
      // If 'hasReloaded' does not exist, remove the script
      this.removeChatbotScript();
    }
  }

  removeChatbotScript(): void {
    const script = document.getElementById('chatbotScript');
    if (script) {
      script.parentNode.removeChild(script);
      window.location.reload();
    }
    this.loading= false;
  }

  authGuard() {
    if (this.cookies.check('encryptedUserSession')) {
      this.router.navigate(['/dashboard']);
    }
  }

  loginWithANT() {
    this.authService.loginWithAnt();
  }
  
}
